module.exports = __webpack_public_path__ + "img/sushicase.b06affc1.jpg";